import { Icon, TIconVariant } from '../icon'
import { useStyles } from './styles'
import { formatNumber } from '@/shared/util/formatNumber'

type BalanceTextProps = {
  balance: number | string
  view?: TIconVariant
  fontStyle?: React.CSSProperties
  textSize?: 'm' | 's' | 'xs'
  iconSize?: number
}

const mSized = {
  fontSize: '32px',
  lineHeight: '32px',
}

const sSized = {
  fontSize: '24px',
  lineHeight: '24px',
}

const xsSized = {
  fontSize: '16px',
  lineHeight: '16px',
}
export const BalanceText = (props: BalanceTextProps) => {
  const { balance, view = 'gamed', textSize = 'm', iconSize = 28, fontStyle } = props
  const { classes } = useStyles({})
  const getTextSize = () => {
    switch (textSize) {
      case 'm':
        return mSized
      case 's':
        return sSized
      case 'xs':
        return xsSized
      default:
        return mSized
    }
  }
  return (
    <div
      className={classes.root}
      style={getTextSize()}
    >
      <div style={fontStyle ? fontStyle : {}}>{formatNumber(balance)}</div>
      <Icon
        view={view}
        width={iconSize}
      />
    </div>
  )
}
